import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';
import { DEFAULT_CURRENCY } from 'src/utils/priceFormatter';

//
//

const BASKETS_URL = 'projects/baskets/v2/';

//

export const getBasketByIdAPI = async ({
  id,
  currency,
}: Types.GetBasketByIdQuery): Promise<Types.GetBasketByIdResponse> => {
  const currencyParam = currency ? currency : DEFAULT_CURRENCY;

  const response = await axiosInstance.get<Types.GetBasketByIdResponse>(
    `${BASKETS_URL}${id}?currency=${currencyParam}&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getBasketByCodeAPI = async ({
  code,
}: Types.GetBasketByCodeQuery): Promise<Types.GetBasketByCodeResponse> => {
  const response = await axiosInstance.get<Types.GetBasketByCodeResponse>(
    `${BASKETS_URL}${code}?fields=estimatedUnitPrice`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getPreferredBasketAPI = async (
  payload: Types.GetPreferredBasketQuery
): Promise<Types.GetPreferredBasketResponse> => {
  const response = await axiosInstance.get<Types.GetPreferredBasketResponse>(
    `${BASKETS_URL}preferred?fields=estimatedUnitPrice`,
    { params: { ...payload } }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getBasketsAPI = async (
  query?: Types.GetBasketsQuery
): Promise<Types.GetBasketsResponse> => {
  const params: Types.GetBasketsQuery = {};

  const currencyParam = query?.currency ? query?.currency : DEFAULT_CURRENCY;

  if (query?.includePublic) params.includePublic = query?.includePublic;
  if (query?.codes) params.codes = query?.codes;
  if (query?.merchantCode) params.merchantCode = query?.merchantCode;

  const response = await axiosInstance.get<Types.GetBasketsResponse>(
    `${BASKETS_URL}?currency=${currencyParam}&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`,
    {
      params,
      paramsSerializer: (params) => {
        return `${query?.codes ? params.codes.map((code: any) => `codes=${code}`).join('&') : ''}${
          params.includePublic ? `&includePublic=${params.includePublic}` : ''
        }${params?.merchantCode ? `&merchantCode=${params.merchantCode}` : ''}`;
      },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response?.data;
};
